import skyforgeBoardJson from '../../../../maps/skyforge/board.json';
import skyforgeDecorationsJson from '../../../../maps/skyforge/decorations.json';
import skyforgeThemeJson from '../../../../maps/skyforge/theme.json';
import skyforgeFxJson from '../../../../maps/skyforge/fx.json';
import skyforgeCameraJson from '../../../../maps/skyforge/camera.json';
import type { MapHandle } from './types';
import type { LoadMapDeps } from './index';
import { assembleMapFromData } from './assemble-map';

/**
 * Assemble and return the default Skyforge MapHandle.
 *
 * The implementation delegates to assembleMapFromData so runtime and editor
 * previews can share the same board, decoration, theme, FX, and camera parsing
 * path with different JSON sources.
 */
export async function assembleSkyforge(deps: LoadMapDeps): Promise<MapHandle> {
  return assembleMapFromData(
    {
      name: 'skyforge',
      board: skyforgeBoardJson,
      decorations: skyforgeDecorationsJson,
      theme: skyforgeThemeJson,
      fx: skyforgeFxJson,
      camera: skyforgeCameraJson,
    },
    deps,
  );
}
